import { useQuery, useQueryClient } from "@tanstack/react-query"
import { getCategoriaAllPadres, getCategoriasItems } from "./Categoria.service"

export function useCategoriaPadre() {
  const queryClient = useQueryClient()
  const { data: categoriasPadre, isLoading: categoriasPadreLoading } = useQuery(
    {
      queryKey: ["getCategoriaAllPadres"],
      queryFn: () => getCategoriaAllPadres(),
      refetchOnWindowFocus: false,
      retry: false,
    }
  )
  const categoriaPadreInvalidation = () =>
    queryClient.invalidateQueries({ queryKey: ["getCategoriaAllPadres"] })

  return {
    categoriasPadre,
    categoriasPadreLoading,
    categoriaPadreInvalidation,
  }
}

export function useCategoriasItems() {
  const queryClient = useQueryClient()
  const {
    data: categoriasItems,
    isLoading: categoriasItemsLoading,
    refetch: categoriasItemsRefetch,
  } = useQuery({
    queryKey: ["getCategoriasItems"],
    queryFn: () => getCategoriasItems(),
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: 1000 * 60 * 60 * 20,
  })
  const categoriaItemsInvalidation = () =>
    queryClient.invalidateQueries({ queryKey: ["getCategoriasItems"] })

  return {
    categoriasItems,
    categoriasItemsRefetch,
    categoriasItemsLoading,
    categoriaItemsInvalidation,
  }
}
